import * as React from 'react';

import { FormikTextBox } from '~commonInfra/components/FormikField';
import { useFormikContext } from '~src/settings/FormikWrapperForStubbing';

import { Messages } from '../../../../codegen/Localize';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { useCompositeValidator, usePositiveIntegerValidator, useRangeValidator } from '../../utils';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';

export type TaggingSectionProps = SiteSettingsForSiteAdminProps<'tagLimit'>;

export const TAGGING_FIELD = 'settings.tagLimit';
export const TAGGING_LIMIT_MIN_RANGE_VALUE = 1;
export const TAGGING_LIMIT_MAX_RANGE_VALUE = 200;

const errorMessage = () => Messages.tagLimitRangeInvalid({MIN_RANGE_VALUE: TAGGING_LIMIT_MIN_RANGE_VALUE + '',MAX_RANGE_VALUE: TAGGING_LIMIT_MAX_RANGE_VALUE + ''});

export function TaggingSection(props: TaggingSectionProps) {
  const formik = useFormikContext<TaggingSectionProps>();

  const validate = useCompositeValidator(
    usePositiveIntegerValidator(errorMessage),
    useRangeValidator(
      TAGGING_LIMIT_MIN_RANGE_VALUE, errorMessage,
      TAGGING_LIMIT_MAX_RANGE_VALUE, errorMessage
    )
  );

  return (
    <SettingsSection testId={'tagging-setting-section'}
                     title={Messages.tableauTagging()}
                     description={Messages.tagLimitDetails()}>

      <FormikTextBox
                    name={TAGGING_FIELD}
                    label={Messages.tagLimit()}
                    testId={'tag-limit-number'}
                    maxLength={50}
                    min={0}
                    type = {'number'}
                    eagerValidation={true}
                    value = {formik.values.settings.tagLimit+''}
                    onChange = {e => formik.setFieldValue(TAGGING_FIELD, +e.target.value)}
                    validate = {validate}
       />

    </SettingsSection>

  );
}

export const TaggingSectionSpecs = componentRegistryEntry({
  name: 'TaggingSection',
  component: TaggingSection
});
